import { Skeleton } from "@runcheetah/ui";
import { cn } from "@/lib/utils";

export interface TableSkeletonProps {
  rows?: number;
  className?: string;
}

export function TableSkeleton({ rows = 6, className }: TableSkeletonProps) {
  return (
    <div className={cn("space-y-3 rounded-lg border bg-card p-4", className)}>
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton key={index} className="h-10 w-full" />
      ))}
    </div>
  );
}
